const isValidEmail = (email) => {
  return String(email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
};

export const validate = (group, name, value) => {

  if (group === "signup") {
    switch (name) {
      case "name": {
        if (!value) return "This field is required";
        return null;
      }
      case "email": {
        if (!value) return "This field is required";
        if (!isValidEmail(value)) return "Please enter valid email address";
        return null;
      }
      case "password": {
        if (!value) return "This field is required";
        if (value.length < 4) return "Password should be atleast 4 chars long";
        return null;
      }
      default: return null;
    }
  }
  else if (group === "login") {
    switch (name) {
      case "email": {
        if (!value) return "This field is required";
        if (!isValidEmail(value)) return "Please enter valid email address";
        return null;
      }
      case "password": {
        if (!value) return "This field is required";
        return null;
      }
      default: return null;
    }
  }
  else if (group === "task") {
    switch (name) {
      case "purpose": {
        if (!value) return "Purpose is required";
        return null;
      }
      case "title": {
        if (!value) return "Title is required";
        if (value.length > 100) return "Max. limit is 100 characters.";
        return null;
      }
      case "date": {
        if (!value) return "Date is required";
        return null;
      }
      case "description": {
        if (!value) return "Description is required";
        if (value.length > 1000) return "Max. limit is 1000 characters.";
        return null;
      }
      default: return null;
    }
  }
  else if (group === "concern") {
    switch (name) {
      case "rootCauseAnalysisFor": {
        if (!value) return "This field is required";
        if (value.length !== 1) return "Should be 1 character.";
        return null;
      }
      case "category": {
        if (!value) return "This field is required";
        if (value.length > 50) return "Max. limit is 50 characters.";
        return null;
      }
      case "subCategory": {
        if (value && value.length > 50) return "Max. limit is 50 characters.";
        return null;
      }
      case "rcaCode": {
        if (!value) return "This field is required";
        if (value.length > 25) return "Max. limit is 25 characters.";
        return null;
      }
      case "concern": {
        if (!value) return "This field is required";
        if (value.length > 500) return "Max. limit is 500 characters.";
        return null;
      }
      case "statement": {
        if (value && value.length > 200) return "Max. limit is 2000 characters.";
        return null;
      }
      default: return null;
    }
  } 
  else {
    return null;
  }

}


const validateManyFields = (group, list) => {
  const errors = [];
  for (const field in list) {
    const err = validate(group, field, list[field]);
    if (err) errors.push({ field, err });
  }
  return errors;
}
export default validateManyFields;